/**
 * Page Header Parallax Effect
 * Alpine.js component for parallax background and sticky title
 */

document.addEventListener('alpine:init', () => {
  Alpine.data('pageHeader', () => ({
    parallaxOffset: 0,
    
    init() {
      this.handleScroll();
      
      // Preserve background image when parallax updates
      this.$watch('parallaxOffset', () => {
        const bgElement = this.$el.querySelector('.c-page-header__bg');
        if (bgElement) {
          const customBgImage = bgElement.getAttribute('data-bg-image');
          if (customBgImage && bgElement.style.backgroundImage !== customBgImage) {
            bgElement.style.backgroundImage = customBgImage;
          }
        }
      });
    },
    
    handleScroll() {
      const scrollY = window.scrollY;
      
      // Calculate parallax offset (moves slower than scroll)
      // Parallax speed: 0.5 = half the scroll speed
      this.parallaxOffset = scrollY * 0.5;
    }
  }));
});
